import { computed } from '@angular/core';
import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';

import type { IAuthSession, IUser } from '@rpgc-ai/shared-interfaces/interfaces/auth.interface';

import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { initialAuthState } from './auth.model';

export const AuthStore = signalStore(
  { providedIn: 'root' },

  // Redux DevTools поддержка
  withDevtools('auth'),

  withState(initialAuthState),
  withComputed((store) => {
    return {
      isAuthenticated: computed<boolean>(() => !!store.user()),
    };
  }),
  withMethods((store) => {
    return {
      setUser(user: IUser) {
        updateState(store, '[Auth] User: Set', { user, isLoading: false, error: null });
      },

      setSession(session: IAuthSession) {
        updateState(store, '[Auth] Session: Set', { session, isLoading: false, error: null });
      },

      updateToken(token: string) {
        const currentSession = store.session();
        if (currentSession) {
          updateState(store, '[Auth] Token: Update', { session: { ...currentSession, token }, isLoading: false, error: null });
        }
      },

      updateUserUpdatedAt(updatedAt: Date) {
        const currentUser = store.user();
        if (currentUser) {
          updateState(store, '[Auth] User: Update', {
            user: { ...currentUser, updatedAt },
            isLoading: false,
            error: null,
          });
        }
      },

      clearUser() {
        updateState(store, '[Auth] User: Clear', { user: null });
      },

      clearSession(): void {
        updateState(store, '[Auth] Session: Clear', { session: null });
      },

      setLoading(isLoading: boolean) {
        updateState(store, '[Auth] Loading: Set', { isLoading });
      },

      setError(error: string) {
        updateState(store, '[Auth] Error: Set', { error, isLoading: false });
      },
    };
  }),
);
